export const MaximumBatchSize = 500; // https://cloud.google.com/firestore/quotas#writes_and_transactions
